import { render, staticRenderFns } from "./PublicClassDetail.vue?vue&type=template&id=6c3ba51b&scoped=true&"
import script from "./PublicClassDetail.vue?vue&type=script&lang=js&"
export * from "./PublicClassDetail.vue?vue&type=script&lang=js&"
import style0 from "./PublicClassDetail.vue?vue&type=style&index=0&id=6c3ba51b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ba51b",
  null
  
)

export default component.exports